<template>
<div style="min-height: 78vh;">
    <div class="advance-search bg-gray-2">
        <div class="container">
            <div class="row justify-content-between">
                <advance-search></advance-search>
                <guided-search></guided-search>
            </div>
        </div>
    </div>
    <main class="main flex-grow-1 js-main">
        <div class="container pt-20 pb-60">
            <div class="filters mb-5">
                <div class="row">
                    <div class="col-12">
                        <ul class="filters-list d-flex align-items-center flex-wrap list-unstyled mx-n15 mb-0">
                            <li class="px-15 pb-15"><span class="total-result">{{totalResources}} results</span></li>
                            <li v-for="(item, $index) in activeTypes" :key="item.id" class="px-15 pb-15"><a href="#" v-on:click.prevent="removeActiveType($index)" class="d-flex align-items-center p-5">{{item.name}} <span class="icon-cross ml-20"></span></a></li>
                            <li v-for="(item, $index) in activeClassifications" :key="item.id" class="px-15 pb-15"><a href="#" v-on:click.prevent="removeActiveClassification($index)" class="d-flex align-items-center p-5">{{item.name}} <span class="icon-cross ml-20"></span></a></li>
                            <li v-for="(item, $index) in activeTargets" :key="item.id" class="px-15 pb-15"><a href="#" v-on:click.prevent="removeActiveTarget($index)" class="d-flex align-items-center p-5">{{item.name}} <span class="icon-cross ml-20"></span></a></li>
                            <li v-for="(item, $index) in activeLanguages" :key="item.id" class="px-15 pb-15"><a href="#" v-on:click.prevent="removeActiveLanguage($index)" class="d-flex align-items-center p-5">{{item.name}} <span class="icon-cross ml-20"></span></a></li>
                            <li v-for="(item, $index) in activeFluencies" :key="item.id" class="px-15 pb-15"><a href="#" v-on:click.prevent="removeActiveFluency($index)" class="d-flex align-items-center p-5">{{item.name}} <span class="icon-cross ml-20"></span></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="totalResources > 0" class="filter-result load-more-holder">
                <div class="row masonry">
                    <resource-card v-for="(item, $index) in resources" :item="item" :key="$index" />
                </div>
            </div>
            <div v-else class="filter-result load-more-holder no-results">
              <p>Your resource search has returned <strong>0 results.</strong></p>
              <br>
              <p>Please try rewording your <strong>search terms</strong><br>
              or try searching from the <strong>advanced search filter options</strong> above.</p>
              <br>
              <p>Alternatively, there is also a <strong>guided search</strong> above that can help guide you through step by step to find the resource you need.</p>
            </div>

            <infinite-loading @infinite="infiniteHandler">
                <div slot="no-more">No more results</div>
                <div slot="no-results"></div>
            </infinite-loading>
             <!-- <div slot="spinner">
                    <div >
                        <a class="load-more btn btn-primary d-block d-flex justify-content-center align-items-center mx-auto py-10" href="./inc/01.html"><img src="/_resources/themes/netvalue/images/loading.svg" alt="image description" width="30" height="30" class="mr-25"> Loading</a>
                    </div>

                </div> -->
        </div>
    </main>
</div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading';
import imagesLoaded from 'imagesLoaded'
import ResourceCard from "../components/ResourceCard";
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import * as utils from '../utils'

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common["Content-Type"] = "application/json";

export default {
    name: "SearchPage",

    beforeRouteEnter (to, from, next) {

        window.dispatchEvent(new Event('resize'));

        next(vm => {
            //clean this us up to hide the advance search
            vm.$store.commit("setSelectedResource", null);
            vm.$store.commit("resetRouteHistory");
        })

    },

    props: [],

    data() {

        let text = utils.getParameterByName('text');

        return {
            page: 25,
            limit: 25,
            text: text,
        };
    },

    components: {
        ResourceCard,
        InfiniteLoading
    },

    computed: {
        ...mapGetters([
            "actionURL"
        ]),
        ...mapState([
            "totalResources",
            "resources",
            "activeTypes",
            "activeClassifications",
            "activeTargets",
            "activeLanguages",
            "activeFluencies"
        ]),

        resourceURL() {
            let param = window.location.search;
            let url = `/home/getData` + param;
            if (param !== "") {
                url = url + `&page=${this.page}`
            } else {
                url = url + `?page=${this.page}`
            }

            return url;
        }
    },

    methods: {
        infiniteHandler($state) {

            // no need to call since no data
            if (this.totalResources < this.limit) {
                $state.complete();
                return;
            }

            axios.get(this.resourceURL, {}).then(({ data }) => {
                if (data.length) {
                    this.page += this.limit;
                    this.$store.commit("setResource", data);
                    this.$nextTick(() => {
                        
                        $('.masonry').imagesLoaded( function() {
                            var holder = jQuery('.load-more-holder'),
                            masonryBox = holder.find('.masonry'),
                            oldBlockHeight = holder.outerHeight();

                            holder.css('height', oldBlockHeight + 'px');
                            masonryBox.masonry('destroy');
                            masonryBox.masonry({
                                itemSelector: '.grid-item',
                                columnWidth: 1,
                                resize: true,
                                isOriginLeft: true,
                                transitionDuration: 0,
                                isAnimated: false,
                                animated: false,
                            });

                            holder.css('height', 'auto');

                            $state.loaded();
                        });
                    });

                } else {
                    $state.complete();
                }
            });
        },

        removeActiveType(index){
            this.$store.commit('removeActiveType', index)
        },
        removeActiveClassification(index){
            this.$store.commit('removeActiveClassification', index)
        },
        removeActiveTarget(index){
            this.$store.commit('removeActiveTarget', index)
        },
        removeActiveLanguage(index){
            this.$store.commit('removeActiveLanguage', index)
        },
        removeActiveFluency(index){
            this.$store.commit('removeActiveFluency', index)
        },
    },

    created() {
    },

    mounted() {

        this.$store.subscribe((mutation, state) => {
            switch (mutation.type) {
                case 'removeActiveType':
                case 'removeActiveClassification':
                case 'removeActiveTarget':
                case 'removeActiveLanguage':
                case 'removeActiveFluency':
                    window.location.href = this.actionURL;
                    break;
                default:
                    break;
            }
        });

        jQuery(function() {
            $('.masonry').imagesLoaded( function() {
                jQuery('.masonry').masonry({
                    itemSelector: '.grid-item',
                    columnWidth: 1,
                    resize: true,
                    isOriginLeft: true,
                    transitionDuration: 0,
                    isAnimated: false,
                    animated: false,
                });
            });
        });
    }
}
</script>
